import { getUser, userIsConnected, userIsPremium } from '#js/utils/user.js';

/**
 * Plenigo
 */
export default class Plenigo {
  /**
   * Constructor
   */
  constructor() {
    this.elements = {
      subscribe: Array.from(document.querySelectorAll('.plenigo-auth__subscribe')),
      myAccount: Array.from(document.querySelectorAll('.plenigo-auth__my-account')),
      logout: Array.from(document.querySelectorAll('.plenigo-auth__logout')),
      login: Array.from(document.querySelectorAll('.plenigo-auth__login')),
    };

    this.elements.logout.forEach((el) => {
      el.removeAttribute('target');
    });

    this.initUser();
    this.updateElements();
  }

  /**
   * Init user.
   */
  async initUser() {
    const user = await getUser();
    window.dispatchEvent(new CustomEvent('frisbii:user:init', { detail: user }));
  }

  /**
   * Update plenigo elements.
   */
  async updateElements() {
    if (!(await userIsConnected())) {
      this.disconnected();
      return;
    }

    this.connected();
  }

  /**
   * On user disconnected.
   */
  disconnected() {
    const hiddenElements = [...this.elements.logout, ...this.elements.myAccount];
    const visibleElements = [...this.elements.login, ...this.elements.subscribe];

    hiddenElements.forEach((el) => {
      el.style.display = 'none';
    });
    visibleElements.forEach((el) => {
      el.style.display = null;
    });
  }

  /**
   * On user connected.
   */
  async connected() {
    const hiddenElements = [...this.elements.login];
    const visibleElements = [...this.elements.logout, ...this.elements.myAccount];

    if (await userIsPremium()) {
      hiddenElements.push(...this.elements.subscribe);
    } else {
      visibleElements.push(...this.elements.subscribe);
    }

    hiddenElements.forEach((el) => {
      el.style.display = 'none';
    });
    visibleElements.forEach((el) => {
      el.style.display = null;
    });
  }
}
